<template>
    <VDialog v-model="visivel" scrollable>
        <ComandaLogDetalhe v-model="comandaLogDetalhe" :comandaLogDetalhe="comandaLogEscolhido"></ComandaLogDetalhe>
        <VCard>
            <Loading ref="loading"></Loading>
            <VToolbar
                dark
                color="primary"
            >
              Histórico da Comanda: {{codigoComanda}}
              <VSpacer></VSpacer>
              <VToolbarItems>
                <VBtn icon dark @click="visivel = false" >
                  <VIcon>close</VIcon>
                </VBtn>
              </VToolbarItems>
            </VToolbar>
            <VCardText>
                <VDataTable :headers="cabecalhos" :items="logCarregado" item-key="vendaPOS"  :pagination.sync="paginacao">
                    <template #items="props">
                        <tr>
                            <td>{{formatarDataHora(props.item.data)}}</td>
                            <td>{{props.item.login}}</td>
                            <td>{{props.item.acaoRealizada}}</td>
                            <td>{{props.item.detalhes}}</td>
                            <td>{{props.item.origem}}</td>
                            <td align='center'>
                                <VTooltip bottom>
                                    <VBtn :disabled="false" slot="activator" color="#A3A1A1" icon flat small
                                        @click="mostraItensLog(props.item)">
                                        <VIcon>visibility</VIcon>
                                    </VBtn>
                                    <span>Mais Detalhes</span>
                                </VTooltip>
                            </td>
                        </tr>
                    </template>
                </VDataTable>
            </VCardText>
            <VCardActions>
                <VLayout justify-end>
                    <VBtn color="primary" @click="visivel = false">Fechar</VBtn>
                </VLayout>
            </VCardActions>
        </VCard>
    </VDialog>
</template>

<script>
    import Loading from "./Loading";
    import ApiService from "../../common/api.service";
    import alerts from "../../common/alerts";
    import datas from "../../mixins/datas";
    import numeros from "../../mixins/numeros";
    import ComandaLogDetalhe from "./ComandaLogDetalhe";

    export default {
        mixins: [datas, numeros],
        methods: {
            mostraItensLog(comandaLogSelecionado) {
                this.comandaLogEscolhido = comandaLogSelecionado
                this.comandaLogDetalhe = true;
            },
        },
        data() {
            return {
                visivel: false,
                comandaLogDetalhe: false,
                comandaLogEscolhido: null,
                logComanda: [],
                paginacao: {
                    page: 1,
                    rowsPerPage: 8,
                    sortBy: 'data',
                    descending: true
                },
                cabecalhos: [
                    {
                        text: "Data",
                        value: "data"
                    },
                    {
                        text: "Login",
                        value: "login"
                    },
                    {
                        text: "Ação Realizada",
                        value: "acaoRealizada"
                    },
                    {
                        text: "Detalhes",
                        value: "detalhes"
                    },
                    {
                        text: "Origem",
                        value: "origem"
                    },
                    {
                        text: "Ações",
                        align: "center",
                        value: "",
                        sortable: false
                    }
                ]
            }
        },
        computed: {
            logCarregado() {
                return this.logComanda;
            }
        },
        props: {
            value: Boolean,
            codigoComanda: Number
        },
        components: {
            Loading,
            ComandaLogDetalhe
        },
        watch: {
            async visivel(v) {
                if (v) {
                    try {
                        [this.logComanda] = (await this.$refs.loading.aguardarPromises([ApiService.get(`comandasLog/logComanda/${this.codigoComanda}`)])).map(r => r.data);
                    } catch (e) {
                        alerts.exibirErro('Não foi possível carregar o histórico da comanda.', e);
                        this.visivel = false;
                        return;
                    }
                } else
                    this.logComanda = [];
                if (v !== this.value)
                    this.$emit('input', v);
            },
            value(v) {
                this.visivel = v;
            }
        }
    }
</script>

<style scoped>

</style>
